import { OnInit, Component, ViewChild } from "@angular/core";
import { HasPermissions, Permissions } from "../../../../core/services/permissions/permissions.model";
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { PermissionsService } from "../../../../core/services/permissions/permissions.service";
import { Employee } from "../../employee.model";
import { MessageBoxComponent } from "../../../../core/shared/message-box.component";
import { IssuesRest } from "../../../../issues/issues.rest";
import { ObjectToSelect } from "../../../../core/shared/objectToSelect.model";
import { UserDetailsRest } from "../../../users/user-details/user-details.rest";
import { EmployeesRest } from "../../employee.rest";
import { EmployeeSignatureModalComponent } from "../employee-signature-modal/employee-signature-modal.component";

@Component({
    selector: 'smp-employee-header',
    templateUrl: 'employee-details-header.component.html',
    styleUrls: ['../../employee-details/employee-details.component.scss']
})

export class EmployeeDetailsHeaderComponent implements OnInit, HasPermissions {
    permissions: Permissions;

    @ViewChild('valForm') public valForm: NgForm;
    @ViewChild(EmployeeSignatureModalComponent) employeeModal: EmployeeSignatureModalComponent;

    public employee: Employee;
    public isNew: boolean;
    public supervisorRequired: boolean;
    public messageBox: MessageBoxComponent;
    
    private departments: ObjectToSelect[];
    private supervisors: ObjectToSelect[];

    constructor(
        private router: Router,
        private route: ActivatedRoute,   
        private issueRest: IssuesRest,
        private userRest: UserDetailsRest,
        private employeesRest: EmployeesRest,
        private permissionService: PermissionsService) {
    }

    setPermissions(claimType: string): void {
        this.permissions = this.permissionService.getUserPermissions(claimType);
    }

    ngOnInit() {
        this.setPermissions("Employee");
    }

    public setModel(employeeDetailsModel: any, isNew: boolean, messageBox: MessageBoxComponent) {
        this.employee = employeeDetailsModel;       
        this.isNew = isNew;
        this.messageBox = messageBox;
        
        if (this.employee.isForeignEmployee == false)
            this.supervisorRequired = true;  

        this.getDepartments();
        this.getSupervisors(this.employee.id);
    }

    public getDepartments() {
        const action = this.issueRest.getDepartments;
        action.call(this.issueRest).subscribe((result: ObjectToSelect[]) => {
            if (result) {
                this.departments = result;
            }
        });
    }

    public isInvalid() {
        return this.valForm.invalid;
    }

    public editSignature() {
      this.employeeModal.setModel(this.employee);
    }

    private getSupervisors(employeeId: number) {
        this.employeesRest.getAvailableSupervisors(employeeId).subscribe(employees => this.supervisors = employees);       
    }

    public test123() {
      console.log('employee: ', this.employee);
    }
}